<template>
  <div class="sb-notification">
    <div class="sb-notification-wrapper date-wrapper">
      <slot name="date" />
    </div>
    <div class="sb-notification-wrapper content-wrapper">
      <slot />
    </div>
    <div class="sb-notification-wrapper actions-wrapper">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  components: {},
  mixins: [],
  props: {},
  data: () => ({}),
  mounted () {},
  destroyed () {},
  watch: {},
  computed: {},
  methods: {},
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>

<style lang='scss'>
.sb-notification {
  justify-content: space-between;
  display: flex;
  margin: 1em 0;
  padding-bottom: 1em;
  .sb-notification-wrapper {
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
